import { EventEmitter, Injectable } from '@angular/core';
import { UserPrompt } from '@panaya/ai-chat/shared';
import { UserFeedbackRequest } from '@panaya/ai-chat/shared';
import { ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AiChatUiEventsService {
    private readonly _launch = new ReplaySubject<void>(1);
    public readonly launch = this._launch.asObservable();
    private readonly _initThreadRequest = new ReplaySubject<void>(1);
    public readonly initThreadRequest = this._initThreadRequest.asObservable();
    public readonly restoreThreadRequest = new EventEmitter<string>();
    public readonly closeThreadRequest = new EventEmitter<void>();
    public readonly promptRequest = new EventEmitter<UserPrompt>();
    public readonly suggestionRequest = new EventEmitter<string>();
    public readonly userFeedbackRequest = new EventEmitter<UserFeedbackRequest>();
    public readonly interruptRequest = new EventEmitter<void>();

    public triggerLaunch(): void {
        this._launch.next();
    }

    public triggerInitThreadRequest(): void {
        this._initThreadRequest.next();
    }
}
